import * as React from 'react'
import dataStore from '../../../store/dataStore.ts'
import { ContactForm } from '../ContactForm.tsx'


interface Props {

}

export const ContactListDesktop: React.FC<Props> = () => {
    const contacts = dataStore(s => s.contacts).sort((a, b) => a.firstName > b.firstName ? 1 : -1)
    const [index, setIndex] = React.useState(0)
    const [isNew, setIsNew] = React.useState(false)

    const handleAddNew = () => {
        setIsNew(true)
    }

    const handleSaved = (savedId?: string) => {
        setIsNew(false)
        if (savedId) {
            const newIndex = contacts.findIndex(c => c._id === savedId)
            if (newIndex >= 0) setIndex(newIndex)
        }
    }

    const contactList = contacts.map((c, i) => (
        <div key={c._id} className={`bg-white border-accent ${!isNew && i === index ? 'border-r-8' : ''}`}>
            <div className={'flex items-center gap-1 border-l-8 border-accent'} onClick={() => {
                setIndex(i)
                setIsNew(false)
            }}>
                <div className={'text-3xl font-semibold pl-2'}>
                    {c.firstName}
                </div>
                <div className={'text-3xl font-semibold'}>
                    {c.lastName}
                </div>
            </div>
        </div>
    ))

    return (
        <div className={'flex flex-col items-start justify-center h-full overflow-y-auto bg-base-100'}>
            <div className={'grid grid-cols-[40%_60%] gap-8 items-start'}>
                <div
                    className={'flex flex-col gap-6 p-4 mt-12 self-start overflow-y-auto rounded-xl bg-primary/30'}>
                    {contactList}
                </div>
                <div className={'w-[35rem] flex flex-col items-center'}>
                    <ContactForm
                        key={isNew ? 'new' : contacts[index]?._id}
                        init={isNew ? undefined : contacts[index]}
                        isCreate={isNew}
                        onSaved={isNew ? handleSaved : undefined}
                    />
                    <button className={'btn btn-primary mt-4'} onClick={handleAddNew}>
                        Add a contact
                    </button>
                </div>
            </div>
        </div>
    )
}

